<form [formGroup]="formGroupRoot">

    <div *ngIf="showLoading" class="flexCenter centerHorizontally centerVertically">
        <mat-spinner></mat-spinner>
    </div>

    <ng-container *ngIf="!showLoading">
        <app-header (CurrentLanguage)=getConfiguration($event)></app-header>
        <ng-container *ngIf="authService.isLoggedIn()">

            <main>
                <section>
                    <aside class="boxShadow">
                        <app-sidebar></app-sidebar>
                    </aside>

                    <article class="boxShadow">
                        <router-outlet></router-outlet>
                    </article>
                </section>

                <app-footer></app-footer>

            </main>
        </ng-container>

        <app-welcome-page *ngIf="!authService.isLoggedIn() && !this.isActivateAccount"></app-welcome-page>

        <app-gipActivateAccount [hash]="hash" *ngIf="!authService.isLoggedIn() && this.isActivateAccount" (isActivateFalse)="activateFalse()"></app-gipActivateAccount>

    </ng-container>

</form>